/* Protein Center — ricerca nel pannello marchi del menu. */
(function () {
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(root) {
    if (root.dataset.pcInit) return;
    root.dataset.pcInit = '1';
    var input = root.querySelector('[data-pc-brands-filter]');
    var groups = root.querySelectorAll('[data-pc-brands-group]');
    var empty = root.querySelector('[data-pc-brands-empty]');
    if (!input) return;

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var any = false;
      groups.forEach(function (g) {
        var shown = 0;
        g.querySelectorAll('[data-pc-brand]').forEach(function (a) {
          var name = a.textContent;
          var i = a.dataset.pcBrand.indexOf(q);
          var ok = !q || i > -1;
          a.hidden = !ok;
          a.innerHTML = ok && q ? esc(name.slice(0, i)) + '<mark>' + esc(name.slice(i, i + q.length)) + '</mark>' + esc(name.slice(i + q.length)) : esc(name);
          if (ok) shown++;
        });
        g.hidden = shown === 0;
        if (shown) any = true;
      });
      if (empty) empty.hidden = any;
    });

    // Invio apre il primo marchio trovato.
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var first = root.querySelector('[data-pc-brand]:not([hidden])');
      if (first) { e.preventDefault(); window.location.href = first.href; }
    });
    // Il tema chiude la tendina con Esc e al click: qui il campo deve restare usabile.
    input.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  function initAll() { document.querySelectorAll('[data-pc-brands]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
